import Show from '../../Show/Show';
import { FC, useEffect, useState } from 'react';
import { Session } from '../../Session/Session';
import { observer } from 'mobx-react';
import { useNavigation } from 'expo-router';
import { useStores } from '../../../hooks/useStores';

/**
   * This component coordinates navigation through a tree of content.
   * Every content frame has a key (aka slug)
   * content frames can have defaultNextFrame which refers to another frame
   * frame content can override defaultNextFrame by setting nextFrame in mobx
   * in the case of surveys:
   * each question has a key and can have a defaultNextKey
   * answers can have a nextKey to override the defaultNextKey
   */


/**
   * The TreeNav store can evolve like this
   *  (start)
   *  currentKey: questionKeyBranched
   *  isFinal: false
   *  isStart: true
   *  path: [questionKeyBranched]
   *  (advance)
   *  currentKey: questionKeyDefault
   *  isFinal: false
   *  isStart: false
   *  path: [questionKeyBranched, questionKeyDefault]
   *  (advance)
   *  currentKey: questionKeyFinal
   *  isFinal: true
   *  isStart: false
   *  path: [questionKeyBranched, questionKeyDefault, questionKeyFinal]
   *  (go back)
   *  currentKey: questionKeyDefault
   *  isFinal: false
   *  isStart: false
   *  path: [questionKeyBranched, questionKeyDefault]
   *  (advance)
   *  currentKey: questionKeyFinal
   *  isFinal: true
   *  isStart: false
   *  path: [questionKeyBranched, questionKeyDefault, questionKeyFinal]
   */


interface TreeNavProps {
  id: string;
  type: 'SESSION' | 'SURVEY';
  pathId?: string;
  reckoningId?: string;
  fromPath?: boolean;
  fromReckoning?: boolean;
}

const _TreeNav: FC<TreeNavProps> = ({
  id,
  type,
  pathId,
  fromPath,
  fromReckoning,
  reckoningId,
}) => {
  const { treeNav } = useStores();
  const navigation = useNavigation();
  const [mounted, setMounted] = useState(false);
  console.log(`render TreeNav ${id} ${type}`);



  useEffect(() => {
    console.log('TreeNav.useEffect', id, type);
    const init = () => {
      console.log('TreeNav.init, treeNav.start (set current)');
      treeNav.start(id);
    };
    const onBlur = () => {
      console.log('TreeNav.onBlur, reset treeNav and survey.current');
      treeNav.clear();
    };
    setMounted(prev => {
      if (!prev) {
        init();
        return true;
      }
      return prev;
    });
    navigation.addListener('blur', onBlur);
    navigation.addListener('focus', init);
    return () => {
      navigation.removeListener('blur', onBlur);
      navigation.removeListener('focus', init);
    };
  }, [id, type, navigation, treeNav]);

  return (
    <Show when={treeNav.tree} keyed>
      {tree => (
        <Session
          sessionId={id}
          pathId={pathId}
          fromPath={fromPath}
          reckoningId={reckoningId}
        />
      )}
    </Show>
  );
};

export const TreeNav = observer(_TreeNav);
